import React, { FC } from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../reducers'

// atoms
import InputField from '../../atoms/InputField'
import SelectField from '../../atoms/SelectField'
import TypeCheckboxGroupField from '../../atoms/TypeCheckboxGroupField'

// interfaces
import { IForm } from '../../types/interfaces'

// utils
import { FORM } from '../../utils/enums'

// validate
import validateGeneralSettingsForm from './validations/validateGeneralSettingsForm'

export type ComponentProps = {}

type Props = InjectedFormProps<IForm, ComponentProps> &
	ComponentProps & {
		handleSubmit: Function
	}

const GeneralFormAttributesForm: FC<Props> = (props) => {
	const { t } = useTranslation()
	const { handleSubmit } = props
	const data = useSelector((state: RootState) => state.formTemplate)

	return (
		<Form layout={'vertical'} onSubmitCapture={handleSubmit}>
			<Row justify={'center'} className={'mt-2 w-full'}>
				<Col span={24}>
					<Field component={InputField} label={t('loc:Form name')} placeholder={t('loc:Enter name')} name={'name'} size={'large'} required />
				</Col>
				<Col span={24}>
					<Field
						component={SelectField}
						label={t('loc:Daktela front')}
						placeholder={t('loc:Select front')}
						name={'queue'}
						loading={data.queue?.isLoading}
						options={data.queue?.data}
						size={'large'}
						required
					/>
				</Col>
				<Col span={24}>
					<Field
						component={SelectField}
						label={t('loc:Database')}
						placeholder={t('loc:Select database')}
						name={'database'}
						loading={data.databases?.isLoading}
						options={data.databases.data}
						size={'large'}
						required
					/>
				</Col>
				<Col span={24}>
					<Field component={TypeCheckboxGroupField} label={t('loc:Form type')} name={'type'} size={'large'} required />
				</Col>
			</Row>
		</Form>
	)
}

const form = reduxForm<IForm, ComponentProps>({
	form: FORM.GENERALE_TEMPLATE_ATTRIBUTES,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	destroyOnUnmount: true,
	validate: validateGeneralSettingsForm
})(GeneralFormAttributesForm)

export default form
